import { render, staticRenderFns } from "./office-name.vue?vue&type=template&id=200559b2&"
import script from "./office-name.vue?vue&type=script&lang=js&"
export * from "./office-name.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports